import { Box } from '@/src/packages/components/ui/Box';
import { Heading } from '@/src/packages/components/ui/Heading';
import { NewsletterForm } from '@/src/packages/components/ui/NewsletterForm';
import { Paragraph } from '@/src/packages/components/ui/Paragraph';
import { Stack } from '@/src/packages/components/ui/Stack';

const JournalEntryNewsletterSignup = () => {
  return (
    <Box className="px-gutter py-24">
      <Stack className="space-y-4">
        <Stack className="space-y-2 text-center">
          <Heading as="h3" className="font-serif text-3xl font-medium">
            Get the latest news, guides and more
          </Heading>
          <Paragraph>
            Liked this article? Sign up to get them delivered straight to your
            inbox.
          </Paragraph>
        </Stack>
        <NewsletterForm />
      </Stack>
    </Box>
  );
};

export { JournalEntryNewsletterSignup };
